import { Heading } from "@/components/ui/heading.jsx";
import telegramIcon from "~/images/icons/telegram.png";
import whatsappIcon from "~/images/icons/whatsapp.png";
import viberIcon from "~/images/icons/viber.png";
import phoneIcon from "~/images/icons/phone-call.png";
import ContactRequestForm from "@/components/ContactRequestForm.jsx";
import { Card, CardContent } from "@/components/ui/card.jsx";
import pageTitle from "@/utils/pageTitle.js";
import { Head } from "@inertiajs/react";
import YandexMap from "../../components/YandexMap";

export default function () {
  return (
    <>
      <Head title={pageTitle("Контакты")}></Head>
      <div className="container mx-auto py-16 px-8 md:px-0">
        <div className="container mx-auto flex flex-wrap space-y-8">
          <div className="w-full lg:w-1/2">
            <div className="prose prose-lg max-w-none">
              <Heading size="h1">Контакты</Heading>

              <p>
                Наша студия находится по адресу: г. Красноярск, переулок
                Вузовский 17
              </p>

              <p>
                Вход со стороны ул. Семафорной, наши неоновые вывески, сложно не
                заметить!
              </p>

              <p>
                Так же для удобства работает пункт выдачи оплаченных готовых
                заказов
              </p>

              <p>
                по адресу: г. Красноярск Батурина 9 (по предварительному
                согласованию)
              </p>

              <p>
                Наш телефон: <a href="tel:+79029274257">8-902-927-42-57</a>
              </p>

              <p>
                Группа в ВК:{" "}
                <a href="vk.com/shararam124" target="_blank" rel="noreferrer">
                  vk.com/shararam124
                </a>
              </p>

              <p>
                Наша почта:{" "}
                <a href="mailto:shararam24@inbox.ru">shararam24@inbox.ru</a>
              </p>

              <p>
                Студия работает: по будням с 10:00 до 20:00, по выходным с 11:00
                до 18:00
              </p>

              <p>
                Что бы получить шары в нерабочее время важно оформить заказ в
                часы работы нашей студии.
              </p>

              <p>Заказы через сайт принимаются круглосуточно! </p>

              <p>Реквизиты:</p>

              <p>ИП Домнин Павел Павлович</p>

              <p>ИНН: 246529494338</p>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <Card>
              <CardContent>
                <Heading size={"h2"}>Напишите нам </Heading>
                <div className="flex space-x-4 items-center py-8">
                  <div>
                    <a
                      href="https://wa.me/79029274257"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={whatsappIcon} className="size-10" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://t.me/shararam24"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={telegramIcon} className="size-10" />
                    </a>
                  </div>

                  <div>
                    <a href="tel:+79029274257" target="_blank" rel="noreferrer">
                      <img src={phoneIcon} className="size-10" />
                    </a>
                  </div>
                </div>

                <ContactRequestForm />
              </CardContent>
            </Card>
          </div>
        </div>

        <YandexMap />
      </div>
    </>
  );
}
